import { clsx } from 'clsx';

const mergeClassNames = (classNames, props) => {
  const transformedClassNames = [];
  for (const className of classNames) {
    if (typeof className === "function") {
      transformedClassNames.push(className(props));
    } else {
      transformedClassNames.push(className);
    }
  }
  return clsx(transformedClassNames);
};

export { mergeClassNames };
//# sourceMappingURL=mergeClassNames.es.js.map
